import {Component, computed, input} from '@angular/core';
import {Maybe, ProductTag} from '@core/interfaces/generated/graphql';
import {NgOptimizedImage} from '@angular/common';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product-tags',
  templateUrl: './product-tags.component.html',
  styleUrls: ['./product-tags.component.scss'],
  imports: [
    NgOptimizedImage,
    NgbTooltip
  ]
})
export class ProductTagsComponent {

  tags = input.required<Maybe<ProductTag>[]>();

  hideCountry = input<boolean>(false);

  tagsToShow = computed(() => {
    return this.tags().filter(tag => {
      if (tag?.type === 'country') {
        return !this.hideCountry();
      }
      return true;
    });
  })

}
